<template>
	<modal
		size="small-medium"
		:hide-footer="true"
		@close="close">
		<template slot="header">
			<h3 class="text-white">{{ $t('Change Password') }}</h3>
		</template>
		<template slot="body">
			<form @submit.prevent="save"  class="pr-3 form-force-password">
				<!-- new Password -->
				<div class="form-group">
					<div class="d-flex justify-content-between">
						<label>{{ $t('New Password') }}</label>
						<span class="font-small mt-1"
								:class="{'very-weak': warningError === 'Weak',
									'weak': warningError === 'Medium',
									'strong': warningError === 'Strong',
							}">
							{{warningError}}
						</span>
					</div>
					<input-password v-model="newPassword" :required="false"/>
					<span class="text-danger text-small" v-if="warningError === 'Weak' && newPassword">{{$t('Please enter a password of at least 8 characters, and use a combination of letters and numbers')}}</span>
				</div>
				<!-- Confirm Password -->
				<div class="form-group">
					<div class="d-flex justify-content-between">
					<label>{{ $t('Confirm Password') }}</label>
						<label class="text-danger text-small" v-if="confirmPassword && confirmPassword !== newPassword">{{$t('Password do not match')}}</label>
					</div>
					<input-password v-model="confirmPassword" :required="true" :notMatch="confirmPassword !== newPassword" />
				</div>
			</form>
			<!-- Submit -->
			<button
				@click="save"
				:disabled="!isFormValid"
				type="submit"
				class="btn btn-submit btn-primary mt-3"
				:class="{ 'is-loading': isSaving }">
				{{ $t('Update Password') }}
			</button>
		</template>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import InputPassword from '@/components/InputPassword.vue';
import { getAxiosErrorMessage } from '@/lib/helper';
import userApi from '@/api/user';

export default {
	name: 'ChangePasswordForm',
	props: {
		data: {
			type: Object,
		},
	},
	components: {
		Modal,
		InputPassword,
	},
	data() {
		return {
			newPassword: '',
			confirmPassword: '',
			isSaving: '',
			warningError: '',
			score: '',
		};
	},
	methods: {
		save() {
			this.isSaving = true;
			const params = this.params;
			const callback = (response) => {
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: this.$t('Change Password'),
					text: message,
				});
				this.isSaving = false;
				this.close();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t('Change Password'),
					text: message,
				});
				this.isSaving = false;
			};
			userApi.forceUpdatePassword(this.data.id, params, callback, errorCallback);
		},
		close() {
			this.$emit('close');
		},
		initData() {
			this.reset();
		},
		reset() {

		},
	},
	computed: {
		params() {
			const params = {
				password: this.newPassword,
			};
			return params;
		},
		isFormValid() {
			return (
				this.newPassword === this.confirmPassword
				&& this.warningError !== 'Weak'
			);
		},
	},
	watch: {
		newPassword() {
			if (this.newPassword !== '') {
				/* eslint-disable global-require */
				const passwordStrength = require('check-password-strength');
				if (this.newPassword.length < 8) {
					this.warningError = 'Weak';
				} else {
					/* eslint-enable global-require */
					this.warningError = passwordStrength(this.newPassword).value;
				}
			}
			if (this.newPassword === '') this.warningError = '';
		},
	},
	created() {
		this.initData();
	},
};
</script>
